






import { Component, Vue } from "vue-property-decorator";
import AuditKebersihanRuangList from "@/components/ppi/audit-kebersihan-ruang/AuditKebersihanRuangList.vue";

@Component({
  components: { AuditKebersihanRuangList }
})
export default class AuditKebersihanRuangPage extends Vue {}
